// We need jQuery
var $ = window.jQuery;

export default function () {
  var customerPrice = 0, agentPayout = 0, deposit = 0, additionalMarkupTotal = 0, additionalMarkupAgent = 0;
  var agentMarginPerc = optionsJS.agentPayout / 100


  $('#package-items .item-price input:enabled').each(function () {
    customerPrice += Number($(this).val());
  });

  $('#flight-items .flight-total input:enabled').each(function () {
    customerPrice += Number($(this).val());
  });

  $('#package-items .item-agent-payout input:enabled').each(function () {
    agentPayout += Number($(this).val());
  });

  additionalMarkupTotal = Number($('#additional-markup input:enabled').val());
  additionalMarkupAgent = additionalMarkupTotal * agentMarginPerc;

  var agentPayoutTotal = agentPayout + additionalMarkupAgent;

  $('#package-items .item-deposit input:enabled').each(function () {
    if (!isNaN($(this).val())) {
      deposit += Number($(this).val());
    }
  });

  //flights exist and include flight deposit toggle is set to yes
  if($('#include-flight-in-deposit').length) {
    if($('#include-flight-in-deposit').find('.acf-switch').hasClass('-on')) {
      $('#flight-items .flight-total input:enabled').each(function () {
        deposit += Number($(this).val())
      })
    }
  }

  let depositMarkup = $('#deposit-markup input').val()
  if(depositMarkup.length) {
    
    let newDeposit = Number($('#deposit-markup input').val()) + deposit;
    
    if(newDeposit > customerPrice) {
      alert('You cannot increase the deposit to a higher value than the Customer Price')
      $('#deposit-markup input').val('')
    } else {
      deposit = newDeposit
    }
  }
  
  $('#total-agent-payout input:enabled').val((agentPayoutTotal).toFixed(2));
  $('#total-price input:enabled').val((customerPrice + additionalMarkupTotal).toFixed(2));
  
  $('#total-deposit input:enabled').val((deposit).toFixed(2));
}
